import React from 'react'
import { record, recordImpression } from '@paypalcorp/fpti'

const withAnalytics = (Component: any) => {
  return (props: any) => (
    <Component {...props} fpti={{ record, recordImpression }} />
  )
}

export default withAnalytics
